<template>
  <router-view />
</template>

<script>
export default {
  name: "ResultSingle"
}
</script>